<div class="container">
  <div class="row">
    <div class="col-lg-7 col-12 mt-4">
      <h4 class="summary-heading">{{ 'cart.itemsSummary' | translate }}</h4>
      <div class="mb-4 mt-4">
        <fgbcl-cart-item [isCheckoutPage]="true"></fgbcl-cart-item>
      </div>
      <button class="btn text-primary fw-bold ps-0 go-back-btn" (click)="goBack()">
        <span class="font-size-14 text-go-back">{{ 'cart.goBack' | translate }}</span>
      </button>
    </div>
    <div class="col-lg-5 col-12 mt-4">
      <!--member details address-->
      <div class="container address-container py-2 mb-3" [ngClass]="{ 'd-none': editingMemberAddress || editingShippingAddress }">
        <div class="position-relative rounded p-2">
          <div class="d-flex justify-content-between mb-3">
            <div class="text-white fw-bold font-size-14">Billing Address</div>
            <div class="cursor-pointer font-size-14 text-tertiary fw-bold" (click)="editMemberAddress()">
              {{ 'billing.address.edit' | translate }}
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <span *ngIf="memberDetail$ | async as member" class="font-size-14 mb-0 d-flex text-white flex-wrap">
                <div>{{ memberAddressForm?.get('Street')?.value ?? member.Street }},&nbsp;</div>
                <div>{{ memberAddressForm?.get('Town')?.value ?? member.Town }},&nbsp;</div>
                <div>{{ memberAddressForm?.get('County')?.value ?? member.County }},&nbsp;</div>
                <div>{{ memberAddressForm?.get('Country')?.value ?? member.Country }},&nbsp;</div>
                <div>{{ memberAddressForm?.get('PostCode')?.value ?? member.PostCode }},&nbsp;</div>
                <div>{{ memberAddressForm?.get('HomeNumber')?.value ?? member.HomeNumber }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--EO member details address view-->

      <!--SHIPPING ADDRESS address-->
      <div class="container address-container py-2 mb-3" [ngClass]="{ 'd-none': editingShippingAddress || editingMemberAddress }">
        <div class="position-relative rounded p-2">
          <div class="d-flex justify-content-between mb-3">
            <div class="text-white fw-bold font-size-14">Shipping Address</div>
            <div class="cursor-pointer font-size-14 text-tertiary fw-bold" (click)="editShippingAddress()">
              {{ 'billing.address.edit' | translate }}
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <span *ngIf="shippingAddress" class="font-size-14 mb-0 d-flex text-white flex-wrap">
                <div>{{ shippingAddressForm?.get('Street')?.value ?? shippingAddress.Street }},&nbsp;</div>
                <div>{{ shippingAddressForm?.get('Town')?.value ?? shippingAddress.Town }},&nbsp;</div>
                <div>{{ shippingAddressForm?.get('County')?.value ?? shippingAddress.County }},&nbsp;</div>
                <div>{{ shippingAddressForm?.get('Country')?.value ?? shippingAddress.Country }},&nbsp;</div>
                <div>{{ shippingAddressForm?.get('PostCode')?.value ?? shippingAddress.Postcode }},&nbsp;</div>
                <div>{{ shippingAddressForm?.get('HomeNumber')?.value ?? shippingAddress.HomeNumber }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!--EO SHIPPING ADDRESS view-->

      <!-- EDIT MEMBER DETAILS ADDRESS FORM -->
      <ng-container *ngIf="editingMemberAddress">
        <div class="container address-container mb-3">
          <div class="position-relative py-2 px-1">
            <div class="d-flex justify-content-between mb-3">
              <div class="text-white font-size-14 pt-2 mb-2 fw-bold">{{ 'address.subheading' | translate }}</div>
              <a
                (click)="clearAddressForm(memberAddressForm)"
                class="text-white heading-text-one mb-1 pt-2 font-size-14 cursor-pointer fw-bold"
                >{{ 'address.clear' | translate }}</a
              >
            </div>

            <form [formGroup]="memberAddressForm" class="font-size-12">
              <!--Street-->
              <div class="form-group form-floating">
                <input
                  id="Street"
                  class="form-control"
                  name="Street"
                  type="text"
                  formControlName="Street"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Street.errors,
                  }"
                  required
                />
                <label for="Street">
                  <span>{{ 'address.street' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'address.street.error' | translate }}</div>
              </div>
              <!--City-->
              <div class="form-group form-floating my-2">
                <input
                  id="Town"
                  class="form-control"
                  name="Town"
                  type="text"
                  formControlName="Town"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Town.errors,
                  }"
                  required
                />
                <label for="Town">
                  <span>{{ 'address.city' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'address.city.error' | translate }}</div>
              </div>
              <!--Country and region-->
              <fgbcl-country-and-regions
                [SeparateRow]="true"
                [Form]="memberAddressForm"
                [HasSubmitted]="hasSubmittedMemberAddress"
              ></fgbcl-country-and-regions>
              <!--Zip code-->
              <div class="form-group form-floating">
                <input
                  id="Postcode"
                  class="form-control"
                  name="Postcode"
                  type="text"
                  formControlName="PostCode"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.PostCode.errors,
                  }"
                  required
                />
                <label for="Postcode">
                  <span>{{ 'address.postcode' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'address.postcode.error' | translate }}</div>
              </div>
              <!--Phone-->
              <div class="form-group form-floating mt-2">
                <input
                  id="HomeNumber"
                  class="form-control"
                  name="HomeNumber"
                  type="text"
                  formControlName="HomeNumber"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.HomeNumber.errors,
                  }"
                  required
                  onkeypress="
                    return (event.charCode != 8 && event.charCode == 0) || (event.charCode >= 48 && event.charCode <= 57);
                  "
                  minlength="8"
                  maxlength="11"
                />
                <label for="Country">
                  <span>{{ 'address.phone' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'address.phone.error' | translate }}</div>
              </div>
            </form>

            <div class="d-flex justify-content-end my-2 mt-3 font-size-14">
              <button class="btn btn-primary fw-bold btn-cancel-save me-2 font-size-14" (click)="cancelAndRebuildForm()">
                {{ 'address.cancel.form' | translate }}
              </button>
              <button
                class="btn btn-secondary text-quartenary fw-bold btn-cancel-save font-size-14"
                (click)="saveMemberDetailAddress()"
              >
                {{ 'address.save.form' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO EDIT MEMBER DETAILS ADDRESS FORM-->

      <!-- EDIT SHIPPING ADDRESS FORM -->
      <ng-container *ngIf="editingShippingAddress">
        <div class="container address-container mb-3">
          <div class="position-relative py-2 px-1">
            <div class="d-flex justify-content-between mb-3">
              <div class="text-white font-size-14 pt-2 mb-2 fw-bold">{{ 'shipping.address.subheading' | translate }}</div>
              <a
                (click)="clearShippingAddressForm(shippingAddressForm)"
                class="text-white heading-text-one mb-1 pt-2 font-size-14 cursor-pointer fw-bold"
              >
                {{ 'address.clear' | translate }}
              </a>
            </div>

            <form [formGroup]="shippingAddressForm" class="font-size-12">
              <!-- Street -->
              <div class="form-group form-floating">
                <input
                  class="form-control"
                  formControlName="Street"
                  [ngClass]="{
                    'is-invalid': hasSubmittedShippingAddress && shippingAddressForm.controls.Street.errors,
                  }"
                />
                <label>{{ 'address.street' | translate }}</label>
              </div>

              <!-- Town -->
              <div class="form-group form-floating my-2">
                <input
                  class="form-control"
                  formControlName="Town"
                  [ngClass]="{
                    'is-invalid': hasSubmittedShippingAddress && shippingAddressForm.controls.Town.errors,
                  }"
                />
                <label>{{ 'address.city' | translate }}</label>
              </div>

              <!-- Country and Region -->
              <fgbcl-country-and-regions
                [SeparateRow]="true"
                [Form]="shippingAddressForm"
                [HasSubmitted]="hasSubmittedShippingAddress"
              ></fgbcl-country-and-regions>

              <!-- PostCode -->
              <div class="form-group form-floating">
                <input
                  class="form-control"
                  formControlName="PostCode"
                  [ngClass]="{
                    'is-invalid': hasSubmittedShippingAddress && shippingAddressForm.controls.PostCode.errors,
                  }"
                />
                <label>{{ 'address.postcode' | translate }}</label>
              </div>

              <!-- Phone -->
              <div class="form-group form-floating mt-2">
                <input
                  class="form-control"
                  formControlName="HomeNumber"
                  minlength="8"
                  maxlength="11"
                  [ngClass]="{
                    'is-invalid': hasSubmittedShippingAddress && shippingAddressForm.controls.HomeNumber.errors,
                  }"
                />
                <label>{{ 'address.phone' | translate }}</label>
              </div>
            </form>

            <div class="d-flex justify-content-end my-2 mt-3 font-size-14">
              <button class="btn btn-primary fw-bold btn-cancel-save me-2" (click)="cancelAndRebuildShippingForm()">
                {{ 'address.cancel.form' | translate }}
              </button>

              <button class="btn btn-secondary fw-bold btn-cancel-save" (click)="saveShippingAddress()">
                {{ 'address.save.form' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO EDIT SHIPPING ADDRESS FORM-->

      <!--summary of items in basket-->
      <ng-container>
        <div class="container address-container p-3">
          <div class="text-white fw-bold font-size-14 mb-3">{{ 'cart.summary' | translate }}</div>
          <div class="row text-white">
            <div class="col-6 fw-bold font-size-14">
              <span class="fw-normal">{{ 'cart.summary.items' | translate }}</span>
            </div>
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pr-4">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pr-4">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
          <ng-container *ngIf="isShippingEnable">
            <div class="row text-white">
              <div class="col-6 fw-bold font-size-14">
                <span class="fw-normal">{{ 'cart.summary.shipping.amount' | translate }}</span>
              </div>
              <div class="col-6 font-size-14 text-end pr-4">{{ shippingamountValue / 100 | FortressCurrencyPipe }}</div>
            </div>
          </ng-container>
          <hr class="w-100" />
          <ng-container *ngIf="!isListHasMerchantItem">
            <div class="d-flex justify-content-between align-items-center text-white">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalPoint' | translate }}</div>
              <div class="col-6 fw-bold font-size-14 text-end">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </div>
          </ng-container>
          <ng-container *ngIf="totalBasketPriceValue > 0">
            <div class="d-flex justify-content-between align-items-center text-white">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalMerchant' | translate }}</div>
              <div class="d-flex align-items-center">
                <div class="col-6 fw-bold font-size-14 text-end">{{ totalBasketPriceValue / 100 | FortressCurrencyPipe }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <div class="payment-type-container" *ngIf="items$ | async as items">
        <div class="text-white fw-bold font-size-14 mb-4">{{ 'cart.payment' | translate }}</div>

        <button
          *ngIf="totalBasketPriceValue > 0"
          class="btn btn-default fw-bold mt-2 w-100 addcard-btn btn-tertiary"
          (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
          [disabled]="!memberAddressForm?.valid || !shippingAddressForm?.valid || editingShippingAddress || editingMemberAddress"
        >
          {{ 'cart.add_new_card' | translate }}
        </button>

        <button
          *ngIf="totalBasketPriceValue == 0"
          class="btn btn-default fw-bold mt-2 w-100 addcard-btn btn-tertiary"
          (click)="payNow()"
          [disabled]="!shippingAddressForm?.valid || editingShippingAddress"
        >
          {{ statusText }}
          <div *ngIf="loading" class="ms-2">
            <fgbcl-loading></fgbcl-loading>
          </div>
        </button>
      </div>

      <fgbcl-errors></fgbcl-errors>
    </div>
  </div>
</div>
